import { render } from "./StudentFinanceData.vue?vue&type=template&id=78732e4f&scoped=true"
import script from "./StudentFinanceData.vue?vue&type=script&lang=js"
export * from "./StudentFinanceData.vue?vue&type=script&lang=js"

import "./StudentFinanceData.vue?vue&type=style&index=0&id=78732e4f&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78732e4f"]])

export default __exports__